import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  cella: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  // Wrapping is the default of every iot cell, and it belongs here rather than in
  // each column. `.ReactTable .rt-td` carries `white-space: nowrap; overflow:
  // hidden; text-overflow: ellipsis`, and its `text-overflow` never shows: the box
  // that overflows is this div, not the inline content of the td. Under
  // `justifyContent: center` an overflowing child spills out of *both* sides, so
  // what an unwrapped text loses is a middle chunk - no ellipsis, and no start of
  // the text either.
  //
  // `justifyContent: center` stays: wrapped text does not overflow, and changing
  // the alignment would touch every iot table for no reason.
  testo: {
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
  },
});

/**
 * The plain text cell of the iot tables. It lives outside every table component
 * on purpose: declared inside a component body it would be a new component type
 * on every render, so React would unmount and remount every cell of the table
 * instead of updating it.
 */
const CellaTesto = ({ testo, className }) => {
  const classes = useStyles();

  return (
    <div className={classes.cella}>
      {/* The column class is *added*, never substituted: one carrying only the
          monospace of the sonda would otherwise drive the wrapping out, and that
          column would go back to cutting its text. */}
      <Typography
        variant="body2"
        component="span"
        className={className ? `${classes.testo} ${className}` : classes.testo}
      >
        {testo}
      </Typography>
    </div>
  );
};

CellaTesto.propTypes = {
  className: PropTypes.string,
  testo: PropTypes.node,
};

export default CellaTesto;
